function PaginationArrow({
  direction,
  color = "#000000",
  size = 36,
}: {
  direction: "left" | "right";
  color?: string;
  size?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        transform={direction === "left" ? "scale(-1, 1) translate(-24, 0)" : undefined}
        d="M9.6998 17.3C9.51647 17.1167 9.4248 16.8834 9.4248 16.6C9.4248 16.3167 9.51647 16.0834 9.6998 15.9L13.5998 12L9.6998 8.10005C9.51647 7.91672 9.4248 7.68338 9.4248 7.40005C9.4248 7.11672 9.51647 6.88338 9.6998 6.70005C9.88314 6.51672 10.1165 6.42505 10.3998 6.42505C10.6831 6.42505 10.9165 6.51672 11.0998 6.70005L15.6998 11.3C15.7998 11.4 15.8708 11.5084 15.9128 11.625C15.9541 11.7417 15.9748 11.8667 15.9748 12C15.9748 12.1334 15.9541 12.2584 15.9128 12.375C15.8708 12.4917 15.7998 12.6 15.6998 12.7L11.0998 17.3C10.9165 17.4834 10.6831 17.575 10.3998 17.575C10.1165 17.575 9.88314 17.4834 9.6998 17.3Z"
        fill={color}
      />
    </svg>
  );
}

export default PaginationArrow;
